type ErrorWithBody = Error & {
    data?: { message?: string };
    responseBody?: string;
};

/** Extracts a user-facing message from AI SDK / API error responses. */
export function extractChatErrorMessage(error: Error | undefined): string | null {
    if (!error?.message) {
        return null;
    }

    const err = error as ErrorWithBody;
    if (err.data?.message) {
        return err.data.message;
    }

    if (err.responseBody) {
        try {
            const parsed = JSON.parse(err.responseBody) as { message?: string };
            if (parsed.message) {
                return parsed.message;
            }
        } catch {
            // ignore parse errors
        }
    }

    try {
        const parsed = JSON.parse(error.message) as { message?: string };
        if (parsed.message) {
            return parsed.message;
        }
    } catch {
        // not JSON
    }

    return null;
}
